import React from "react"
import ReactDOM from "react-dom"
import FlightSearchBar from "./flight-search-bar-component"
import { isMobile } from "react-device-detect"

export default class FlightSearchBarModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.locale = (document.body && document.body.dataset.language) || "da"
    self.tabIcons = elem.dataset.tabIcons && JSON.parse(elem.dataset.tabIcons)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<FlightSearchBar {...self.modelJson} {...self.tabIcons} locale={self.locale} showTime={isMobile ? false : true} />, self.elem)
  }
}
